import { TableContainer } from '@mui/material'
import Checkbox from '@mui/material/Checkbox'
import Chip from '@mui/material/Chip'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import { DigitalAsset } from '@promoboxx/graphql-gateway-types'
import I18n from 'i18n-js'
import moment from 'moment'
import { makeStyles } from 'tss-react/mui'

import Media from './Media'
import { BrandsById } from './useCurrentIds'

const useStyles = makeStyles()((theme) => ({
  mediaContainer: {
    cursor: 'pointer',
    border: '1px solid #e0e0e0',
    borderRadius: '4px',
  },
  chip: {
    marginRight: '4px',
    marginBottom: '4px',
  },
}))

type DigitalAssetTableProps = {
  selectAll: React.ReactNode
}

const DigitalAssetTable: React.FC<
  React.PropsWithChildren<DigitalAssetTableProps>
> = ({ children, selectAll }) => {
  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell padding="checkbox">{selectAll && selectAll}</TableCell>
            <TableCell />
            <TableCell>{I18n.t('downloadables.name')}</TableCell>
            <TableCell>{I18n.t('downloadables.dimensions')}</TableCell>
            <TableCell>{I18n.t('downloadables.created')}</TableCell>
            <TableCell>{I18n.t('downloadables.brand')}</TableCell>
            <TableCell>{I18n.t('downloadables.tags')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>{children}</TableBody>
      </Table>
    </TableContainer>
  )
}

export default DigitalAssetTable

type DigitalAssetRowProps = {
  digitalAsset: DigitalAsset
  isSelected: boolean
  onSelect: any
  brands: BrandsById
  onShowPreview: (digitalAsset: DigitalAsset) => void
}

export const DigitalAssetRow: React.FC<
  React.PropsWithChildren<DigitalAssetRowProps>
> = ({ digitalAsset, isSelected, onSelect, brands, onShowPreview }) => {
  const { classes } = useStyles()
  return (
    <TableRow>
      <TableCell padding="checkbox" style={{ width: 20 }}>
        <Checkbox
          checked={isSelected}
          onChange={(e) => onSelect(e, !isSelected, digitalAsset)}
        />
      </TableCell>
      <TableCell style={{ width: 60 }}>
        <div
          className={classes.mediaContainer}
          onClick={() => onShowPreview(digitalAsset)}
        >
          <Media digitalAsset={digitalAsset} />
        </div>
      </TableCell>
      <TableCell style={{ width: 60 }}>{digitalAsset.name}</TableCell>
      <TableCell
        style={{ width: 60 }}
      >{`${digitalAsset.file?.width} x ${digitalAsset.file?.height}`}</TableCell>
      <TableCell style={{ width: 60 }}>
        {moment(digitalAsset.created_at || '').format('L')}
      </TableCell>
      <TableCell style={{ width: 60 }}>
        {brands[digitalAsset.associable_id]?.name}
      </TableCell>
      <TableCell style={{ width: 60 }}>
        {digitalAsset?.tag_list?.map((tag: string) => (
          <Chip className={classes.chip} size="small" label={tag} />
        ))}
      </TableCell>
    </TableRow>
  )
}
